/**
 * What a router is REALLY running, for the card and the Updates tab.
 *
 * A router carries an image version (2.6.22) and, after a no-reboot update,
 * an update version on top (2.6.23). Showing only the image made a router that
 * had just taken 2.6.23 read "still .22" (Ray, 2026-09-28) — the same
 * invisibility that had him distrust no-reboot updates for a month.
 */
export const fwBase = (v?: string | null): string => String(v ?? '').split('-')[0];

const cmp = (a: string, b: string): number => {
   const pa = fwBase(a).split('.').map((n) => parseInt(n, 10) || 0);
   const pb = fwBase(b).split('.').map((n) => parseInt(n, 10) || 0);
   for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
      const d = (pa[i] ?? 0) - (pb[i] ?? 0);
      if (d) return d;
   }
   return 0;
};

export function effectiveRouterVersion(
   image?: string | null,
   bundle?: string | null
): { shown: string; detail: string | null } {
   const img = fwBase(image);
   const upd = fwBase(bundle);
   if (upd && cmp(upd, img) > 0) {
      return { shown: upd, detail: `Image ${img} + no-reboot update ${upd}` };
   }
   return { shown: img, detail: null };
}
